import { FilterTag, MessagingMessageDistribution, MessagingMessagePushButton } from '..';
import {
  MESSAGE_HORIZONTAL_LOCATION,
  MESSAGE_OPEN_LOCATION,
  MESSAGE_POSITION,
  MESSAGE_VERTICAL_LOCATION,
} from '../../constants/communication.constant';
import { ClickMode } from '../messaging-message-type.model';
import { MessagingMessageField } from './messaging-message-field.model';
import { NativeAdTemplate } from './nativead-template.model';

export interface MessagingMessageFormat {
  attachments: Array<any>;
  bcc: Array<string>;
  bg_color: string;
  can_close: boolean;
  daily_redeem_limit: number;
  fields: Array<MessagingMessageField>;
  frecuency: number;
  hide_after_days: number;
  hide_on_max_redeem: boolean;
  horizontal_location: MESSAGE_HORIZONTAL_LOCATION;
  html_body: string;
  image_url: string;
  max_redeems: number;
  message: string;
  open_location: MESSAGE_OPEN_LOCATION;
  position: MESSAGE_POSITION;
  promo_code: string;
  sender_email: string;
  sender_name: string;
  shown_time: number;
  subject: string;
  tab_index: number;
  tab_title: string;
  tag: string;
  target_url: string;
  template_id: string;
  text_color: string;
  title: string;
  vertical_location: MESSAGE_VERTICAL_LOCATION;
  life: number;
  rate: number;
  sound: string;
  url: string;
  buttons: Array<MessagingMessagePushButton>;
  clickMode: ClickMode;
  distribution: MessagingMessageDistribution[];
  languageVersions: { [key: string]: Partial<MessagingMessageFormat> };
  filterTags: Pick<FilterTag, 'name'>[];
}

export interface MessagingMessageFormatView {
  __frecuency: string;
  __frecuencyAlways: boolean;
  __hideAfter90Days: boolean;
  __imageFile: File;
  __nativeAdTemplate: NativeAdTemplate;
}

export const MESSAGING_MESSAGE_FORMAT_TESTAB_CLONABLE_KEYS: Readonly<
  Array<keyof (MessagingMessageFormat & MessagingMessageFormatView)>
> = Object.freeze([
  '__hideAfter90Days',
  '__imageFile',
  '__nativeAdTemplate',
  'bcc',
  'bg_color',
  'can_close',
  'daily_redeem_limit',
  'fields',
  'hide_on_max_redeem',
  'horizontal_location',
  'html_body',
  'image_url',
  'life',
  'max_redeems',
  'message',
  'open_location',
  'position',
  'promo_code',
  'rate',
  'sender_email',
  'sender_name',
  'shown_time',
  'sound',
  'subject',
  'tab_index',
  'tab_title',
  'title',
  'tag',
  'target_url',
  'template_id',
  'text_color',
  'url',
  'vertical_location',
  'buttons',
  'clickMode',
]);
